import { Link } from "react-router";
import type { BelegArt } from "@talentkontor/domain";
import { useStaffWorkspace } from "../app/session";
import { t } from "../lib/sprache";

/**
 * Inhaber 30.10.2026: In jedem Bereich, der Belege erzeugt, ein sichtbarer Weg zum Aussehen des PDFs (PDF-Vorlagen, 0456).
 * Nur mit dem Recht „Vorlagen bearbeiten“; ohne das Recht kein toter Link.
 */
const TIPP: Record<BelegArt, () => string> = {
  invoice: () => t("Wie Rechnungen und Gutschriften als PDF aussehen", "How invoices and self-billing invoices look as PDF"),
  dunning: () => t("Wie Mahnschreiben als PDF aussehen", "How dunning letters look as PDF"),
  offer: () => t("Wie Angebote als PDF aussehen", "How offers look as PDF"),
  contract: () => t("Wie Verträge als PDF aussehen", "How contracts look as PDF"),
};

const ZIEL: Record<BelegArt, string> = {
  invoice: "/agentur/einstellungen/pdf-vorlagen?art=invoice",
  dunning: "/agentur/einstellungen/pdf-vorlagen?art=dunning",
  offer: "/agentur/einstellungen/pdf-vorlagen?art=offer",
  contract: "/agentur/einstellungen/pdf-vorlagen?art=contract",
};

export function PdfDesignLink({ art }: { art: BelegArt }) {
  const ws = useStaffWorkspace();
  if (!ws.can("edit_templates")) return null;
  return (
    <Link className="btn tk-pdf-design-link" to={ZIEL[art]} title={TIPP[art]()} aria-label={t("PDF-Design", "PDF design")}>
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" /><path d="M14 3v5h5" /></svg>
      <span className="tk-pdf-design-text">{t("PDF-Design", "PDF design")}</span>
    </Link>
  );
}
